import React, { ComponentType } from "react";
import { ViewerContext } from "./ViewerContext";

export interface ViewerProps {
  viewer: jigsaw.Viewer;
  bookData: jigsaw.BookData;
}

export default function withViewer<P extends ViewerProps>(
  Component: ComponentType<P>
): ComponentType<Omit<P, keyof ViewerProps>> {
  return function ComponentWithViewer(props) {
    return (
      <ViewerContext.Consumer>
        {value =>
          value.viewer && value.bookData ? (
            <Component
              {...(props as P)}
              viewer={value.viewer}
              bookData={value.bookData}
            />
          ) : null
        }
      </ViewerContext.Consumer>
    );
  };
}
